import { jsx as i } from "react/jsx-runtime";
import { BaseTabs as t } from "./index.es901.js";
const o = "tertiary-tabs-component", r = (e) => /* @__PURE__ */ i(t, { testId: e.testId || o, ...e, variant: "tertiary" });
r.List = t.List;
r.Trigger = t.Trigger;
r.Content = t.Content;
export {
  o as TERTIARY_DEFAULT_TESTID,
  r as TertiaryTabs
};
//# sourceMappingURL=index.es125.js.map
